import Banner from 'components/Banner';
import { data } from './mockdata';
import GradientText from 'components/GradientText';
import resourcesBanner from 'images/resourcesBanner.jpg';
import ProductCards from 'components/ProductCards/index';
import image from 'images/small-images-inside-text/Image.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';

const Resources = () => {
    return (
        <>
            <Banner title="Resources" image={resourcesBanner} buttonText="LEARN MORE" />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>agricultural solutions</LabelButton>
                        <GradientText>
                            Discover valuable resources
                            <br />
                            <em>
                                to enhance your <img src={image} alt="decor" /> agricultural journey
                            </em>
                        </GradientText>
                        <div className="offset-left-4 max-width-760">
                            <GradientText size="super-small">
                                Explore our{' '}
                                <em>
                                    complex crop nutrition programs and the results
                                    <br />
                                    of our trials
                                </em>{' '}
                                to learn how to care for your plants for optimal yields.
                            </GradientText>
                        </div>
                    </div>
                </div>
            </section>

            <ProductCards data={data} />
        </>
    );
};

export default Resources;
